import { Component } from '@angular/core';
import { Route, Router } from '@angular/router';

@Component({
  selector: 'app-tnactive-tenant',
  imports: [],
  templateUrl: './inactive-tenant.html',
  styleUrl: './inactive-tenant.css',
})
export class InactiveTenant {
  constructor(private router: Router) {}

  goToHome() {
    this.router.navigate(['']);
  }
}
